import { webStorage } from 'sidecar-utilities'

export const NAV_SHAPE_KEY = 'navShape'

/**
 * The labels of the nav we're about to render, deduped and in order. Deduped
 * because the account entry appears twice — `md:hidden` and `max-md:hidden` —
 * while the static shell draws one responsive bar. Returned as a string so it
 * can be a `useEffect` dep: `getGlobalNavItems` rebuilds its objects every
 * render, so an array is never reference-equal to the last.
 *
 * @param {Array} navItems - Items as returned by `getGlobalNavItems`.
 * @returns {string} Pipe-joined titles, empty when there are no items.
 */
export const getNavShapeKey = (navItems = []) =>
  [...new Set(navItems.map(item => item?.title).filter(Boolean))].join('|')

/**
 * Caches the nav's labels for the static app shell in `index.html`, which
 * paints the chrome during `?splash=false` crossings in from member-app —
 * before this bundle exists, so it can't call `getGlobalNavItems` itself
 * (#MX-5286).
 *
 * Caching what actually rendered beats duplicating the item list in static
 * markup, because the list depends on data markup can't see: ACA accounts have
 * no "Find care", an impersonating admin gets a different bar.
 *
 * @param {string} navShapeKey - The value from `getNavShapeKey`.
 */
export const cacheNavShape = navShapeKey => {
  const titles = navShapeKey ? navShapeKey.split('|') : []
  webStorage.setItem(NAV_SHAPE_KEY, JSON.stringify(titles))
}
